/**
 * Returns true.
 *
 * @returns {boolean} true.
 * @example
 * stubTrue() // Returns true
 */
export function stubTrue(): boolean {
  return true;
}
